export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="w-full bg-brand-martinique pt-32 pb-8 mb-[37px]">
      <div className="max-w-[1440px] mx-auto px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 lg:gap-14 mb-8">
          <div className="flex items-center">
            <img
              src="/assets/images/hole-logo-dark-bg.svg"
              alt="HOLE Foundation Logo"
              className="h-[99px] w-auto"
            />
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 lg:gap-12">
            <a
              href="#"
              className="text-white font-kepler text-[15px] font-medium leading-[120%] tracking-[-0.3px] hover:text-brand-orange transition-colors"
            >
              <span className="underline">Download Kit</span> (Coming Soon)
            </a>
            <a
              href="mailto:info@theholetruth.org"
              className="text-white font-kepler text-[15px] font-medium leading-[120%] tracking-[-0.3px] underline hover:text-brand-orange transition-colors"
            >
              Contact Us
            </a>
            <button
              onClick={scrollToTop}
              className="text-white font-kepler text-[15px] font-medium leading-[120%] tracking-[-0.3px] hover:text-brand-orange transition-colors"
            >
              Back to the top
            </button>
          </div>
        </div>

        <div className="border-t border-black/10 pt-10 pb-5">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
            <div className="flex flex-wrap items-center gap-6">
              <a
                href="#"
                className="text-white font-agency text-sm font-bold leading-5 underline hover:text-brand-orange transition-colors"
              >
                © HOLE Foundation
              </a>
              <a
                href="/privacy"
                className="text-white font-agency text-sm font-bold leading-5 underline hover:text-brand-orange transition-colors"
              >
                Legal & Privacy
              </a>
            </div>

            <div className="text-white font-agency text-sm font-bold leading-5">
              © 2025 All Rights Reserved
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
